import React from 'react';
import {
    Navbar,
    // Hero,
    // ProductIntro,
    // Caution,
    // ProductFeatures,
    // ProductFeatures2,
    // DownloadCTA,
    Footer
} from '../components';
// import OtherBusinesses from '../components/OtherBusinesses';
import Seo from '../components/Seo';
import Home from '../components/home/Home';


function Index() {
    return (
        <div className="homepage">
            {/* No title: the home page uses the default "WAYAQUICK - Start accepting payments in minutes" */}
            <Seo description="WayaQuick is one platform that lets you sell wherever your customers are — online, in-person, anywhere in the world. Start accepting payments in minutes." />
             <Navbar />
            {/* <Hero />
            <ProductIntro />
            <ProductFeatures />
            <ProductFeatures2 />
            <DownloadCTA />
            <Caution />
            <OtherBusinesses /> */}
            <Home />
            <Footer /> 
            
        </div>
    )
}

export default Index
